module.exports = __webpack_public_path__ + "images/img_IP_7-450c6f4679.png";